import React, { Component } from 'react';
import _ from 'underscore';
export default class ProgressBar extends Component {
    render() {
        return (
            <div className={"step-status step-" + this.props.step}>
                <div>
                    {_.times(this.props.count, (i) => {
                        return (<span key={"status-" + i} className={(i < this.props.step ? 'on' : '')}></span>);
                    })}
                </div>
            </div>
        );
    }
}